export const uriBase = "https://api.agendamiento.keralty.myintelli.net";
export const url = `${uriBase}`;
export const urlKeyHost = "http://localhost:5000";
export const keyRecaptcha = "6LdSkPEaAAAAAJ6Jichk-ml7K_-c0RfOY2HqQKZM";
export const keyGoogle = "AIzaSyAttwscXTcDTs4TGaUWOmnpWk15apPHmf8";
export const getUrlPhoto = (url) =>
  url.indexOf("http") >= 0 ? url : `https://api.keralty.myintelli.net/file/${url}`;
